
import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid,  LinearProgress,  Paper, TextField } from '@mui/material';
import { useState } from 'react';
import {  AutoCompleteCliente01 } from '../../../shared/forms';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { Relatorios } from '../../../shared/services/api/relatorios/relatorios';
import RelatorioVendas from './relatoriosvenda';

           
export const RelatoriosVendas: React.FC = () => {                      
  const [isLoading, setIsLoading] = useState(false);         
  const [uuidcli, setUidcli] = useState('');  
  const [grupo, setgrupo] = useState('');  
  const [msg, setMsg] = useState('');  
  const [openalert, setOpenAlert] = useState(false);                    
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(dayjs()); 
  const [dataFinal, setDataFinal] = useState<Dayjs | null>(dayjs());      
              
  const handleSave = () => {                           
    Relatorios                  
      .RelatorioVendas(grupo, uuidcli, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))   
      .then((result) => {           
        setIsLoading(false);              
        if (result instanceof Error) { 
          setMsg(result.message); 
          setOpenAlert(true);                              
        }else {   
          if(result.length > 0){
            RelatorioVendas(result,  `Período :${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`); 
          }else{
            setMsg('Não a Registros');
            setOpenAlert(true);
          }
        }             
      });              
  };          
   const handleCloseAlert = (
      event?: React.SyntheticEvent | Event,
      reason?: SnackbarCloseReason,
    ) => {
      if (reason === 'clickaway') {
        return;
      }                        
      setOpenAlert(false);
    };
  const handlecliente= (uuidcli: string | undefined) => {    
    if (uuidcli != null) {     
      setUidcli(uuidcli);                  
    }else{                       
      setUidcli('');                         
    }                 
  };   
  const handleGrupoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setgrupo(event.target.value); 
  };
    
 

  return (
    <Box  alignItems="center" width='auto' alignContent='center' height="auto"  display="flex" flexDirection="column"  >
     <Snackbar 
                open={openalert}        
                autoHideDuration={1200}           
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}  
              >
            <Alert  
              onClose={handleCloseAlert}        
              severity="error"         
              variant="filled"                
              sx={{ width: '100%' }}            
            >         
              {msg}           
            </Alert>         
          </Snackbar>
      <Box gap={1}  padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" margin={1}  alignContent='center'></Box>
      <Box   width='auto' alignItems="center"  component={Paper} height="auto" margin={1} 
      
        alignContent='center'>       
        <DialogTitle>Relatório de Vendas</DialogTitle>
        <DialogContent  dividers>    
          
          {isLoading && (           
            <Grid item>  
              <LinearProgress variant='indeterminate' />  
            </Grid>                      
          )}   
          <Grid container  padding={1} item direction="row" gap={2}>
            <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <AutoCompleteCliente01
                  uuidcli={handlecliente} 
                />                    
              </Grid> 
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                   
                   label="Grupo"
                  value={grupo} // Define o valor atual do campo com o estado
                  onChange={handleGrupoChange} // Chama a função para atualizar o estado ao digitar
                  variant="outlined"
                 fullWidth
                 size='small'
                />                    
              </Grid> 
              
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format='DD/MM/YYYY'    
                    value={dataInicial}
                    onChange={(newValue) => setDataInicial(newValue)} 
                    label='Data Inicial'
                    slotProps={{
                      textField: {    
                        size:'small',
                      }
                    }}
                  />
                </LocalizationProvider>   
              </Grid>     
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>  
                  <DatePicker
                    format='DD/MM/YYYY'
                    value={dataFinal}
                    onChange={(newValue) => setDataFinal(newValue)} 
                    label='Data Final'
                    slotProps={{
                      textField: {    
                        size:'small',
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>   
            </Grid>        
          </Grid>         
        </DialogContent>     
        <DialogActions>
          <Button sx={{ minWidth:'30%'  }} variant='outlined' autoFocus onClick={handleSave}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   